export default __webpack_public_path__ + "static/media/utility1.e4ebb6e0.svg";